<template>
  <v-container fluid class="pa-0 colorbg">
    <v-container class="background py-10">
      <v-row>
        <v-col md="5" sm="6" cols="12">
          <v-img
            alt="cards image"
            class="shrink mx-auto"
            contain
            src="../../assets/png/MockUp_Cards.png"
            width="458px"
            height="366px"
          />
        </v-col>
        <v-col md="7" sm="6" cols="12" class="my-auto">
          <div class="card_title my-3">
            {{ card.title }}
          </div>
          <div class="card_text my-2">
            {{ card.text }}
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import lang from "../../lang/pt.json";

export default {
  name: "Card",

  data: () => ({
    card: lang.home.card,
  }),
};
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

.background {
  background-image: url(../../assets/svg/BG_Card.svg);
  background-size: cover;
  background-repeat: no-repeat;
}

.card_title {
  color: white;
  font-family: nexa_bold;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 24px;
}

.card_text {
  color: white;
  font-family: "Roboto" !important;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 24px;
}

.colorbg {
  background: map-get($theme-colors, "backgroundcard");
  background-color: map-get($theme-colors, "dark-blue");
}
</style>
